export default __webpack_public_path__ + "static/media/tl2.3f0bbad5.webp";